import {
  SESSION_STORAGE_PREFIX,
  validateKey,
} from 'app/models/sessionStorage/constants';
import * as storageSelectors from 'app/models/storage/selectors';

const getSessionStorageState = state => state.get(SESSION_STORAGE_PREFIX);

export const wasSessionStorageInitiallyAvailable =
  storageSelectors.wasStorageInitiallyAvailable(getSessionStorageState);

/**
 * @deprecated Use StorageContext instead
 */
export const getItem = storageSelectors.getItem(validateKey, getSessionStorageState);

/**
 * @deprecated Use StorageContext instead
 */
export const hasItem = storageSelectors.hasItem(validateKey, getSessionStorageState);
